import { FC } from 'react';
import Link from 'components/common/Link/Link';
import * as K from 'common/constants';
import ArrowIcon from '@mui/icons-material/Redo';
import AddIcon from '@mui/icons-material/Add';

import ELEMENT from 'common/element';
import './EmptyDashboardTips.scss';

/**
 * This component is show when a dashboard doesn't have any graphs added to it. It shows tips on adding graphs to dashboard
 * via the search page or the dashboard toolbar.
 */
const EmptyDashboardTips: FC<{ isTabbed: boolean }> = ({ isTabbed }) => (
  <div className="EmptyDashboardTips">
    <div className="EmptyDashboardTips__LeftTip">
      {isTabbed ? (
        <span>Tab is empty. To move an item from another tab, click "More" in the item, then select "Move to Tab"</span>
      ) : (
        <>
          <span>Dashboard is empty. To add graphs:</span>
          <ol className="EmptyDashboardTips__List">
            <li>
              Go to the&nbsp;
              <Link href={K.ROUTE.EVENTS} className="bold" testId={ELEMENT.dashboardEmptySearchLink}>
                Search
              </Link>
              &nbsp;page
            </li>
            <li>Search for results you want to visualize</li>
            <li>Click Save &gt; Save to Dashboard</li>
          </ol>
        </>
      )}
    </div>
    <div className="EmptyDashboardTips__RightTip">
      <ArrowIcon fontSize="medium" className="EmptyDashboardTips__ArrowIcon" />
      <span>
        Or click
        <AddIcon className="EmptyDashboardTips__AddIcon" />
        if you know what you want to add
      </span>
    </div>
  </div>
);

export default EmptyDashboardTips;
